var _rect, _rect2, _text, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFujitsu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    role: "img",
    "aria-label": "Fujitsu",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 28,
    fill: "#ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 28,
    fill: "none",
    stroke: "#dfe3e8",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "50%",
    dominantBaseline: "middle",
    textAnchor: "middle",
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 34,
    fontWeight: 800,
    fill: "#e60012"
  }, "FUJITSU")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 58,
    r: 9,
    fill: "#e60012"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFujitsu);
export default __webpack_public_path__ + "static/media/fujitsu.486b43c0ef57e3e3512bc1292d625fd3.svg";
export { ForwardRef as ReactComponent };